"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _Tabs = _interopRequireDefault(require("../Tabs.context"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Tab = function Tab(_ref) {
  var active = _ref.active,
      children = _ref.children,
      title = _ref.title;
  var context = (0, _react.useContext)(_Tabs["default"]);
  var activeItem = context.activeItem,
      provider = context.provider;

  if (!context || provider !== 'tabs') {
    throw new Error('<Tab /> must be a child of <Tabs />');
  }

  if (activeItem === title) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-active": active,
      "data-title": title
    }, children);
  }

  return null;
};

Tab.propTypes = {
  /** Content of the tab */
  active: _propTypes.bool,

  /** Content of the tab */
  children: _propTypes.node,

  /** Title of the tab */
  title: _propTypes.string.isRequired
};
Tab.defaultProps = {
  active: false,
  children: undefined
};
Tab.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Tab",
  "props": {
    "active": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Content of the tab",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "children": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Content of the tab",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "title": {
      "description": "Title of the tab",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = Tab;
exports["default"] = _default;